exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#Inquiry[data-v-17c12922] {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n", ""]);
